import React, { useEffect } from 'react';
import { Form, Row, Col, Image } from 'react-bootstrap';
import { Select } from 'components';
import { transformForSelect } from 'util/transformHelpers';
import plusIcon from 'assets/img/plus-icon.png';
import { ADDRESS_STEPS } from '../../constants';

export default function StepOne({
  handleSubmit,
  userAddress = [],
  setCurrentStep,
  setAddressOptions,
  addressOptions,
}) {
  const handleAddNewAddress = () => {
    setCurrentStep(ADDRESS_STEPS.TWO);
  };

  useEffect(() => {
    const formattedUserAddress = userAddress.map((address) => {
      const label = `${address.direccion} #${address.codigoPostal} ${address.ciudad} ${address.estado}`;

      return {
        ...address,
        label,
      };
    });

    setAddressOptions(transformForSelect(formattedUserAddress, 'id', 'label'));
  }, [userAddress]);

  return (
    <Form id="address" onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} className="p-0">
          <Select
            options={addressOptions}
            name="address"
            label="Dirección*"
            lastField="Agregar nueva dirección"
            onSelectLastField={handleAddNewAddress}
            lastFieldIcon={
              <div className="mx-1">
                <Image src={plusIcon} />
              </div>
            }
          />
        </Col>
      </Row>
    </Form>
  );
}
